import {Component} from '@angular/core';
import { NavController, NavParams ,ViewController ,ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {Events} from 'ionic-angular';
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'dropship-location-add-popup',
  templateUrl: 'dropship-location-add-popup.html'
})
export class DropshipLocationAddPopup{

  dropshipLocation : any;
  user:any;
  callStatus = 0;

  formStatus = false;
  buttonText = "";
  firstName = "";
  lastName = "";
  phone = "";
  pageTitle = "";
  emailReadOnly= false;
  userNameReadOnly= false;


  userUnique = true; // true for update only
  countries = [];
  provinces = [];
  companyName = ""
  mask;
  maskLength:Number = 10;


	constructor(private nav:NavController,
    private api:Api,
    private params: NavParams,
    private cartManager:CartManager,
    private msgManager:MsgManager,
    private viewController:ViewController,
    private toastController:ToastController,
    private events:Events,
    private gVLogger: GVLogger){
    this.dropshipLocation = this.params.get("dropshipLocation");
    this.companyName = this.params.get("companyName");

    console.log("VVVVVV " + this.companyName)
    this.dropshipLocation.companyName = this.companyName
    this.gVLogger.log("dropship location : " + this.dropshipLocation);
    this.getCountries();
    this.getProvincesWhileEditing(this.dropshipLocation.country)


    if (localStorage.getItem('countryCode').length == 2) {
      this.mask = ['+',/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else if (localStorage.getItem('countryCode').length == 3) {
      this.mask = ['+',/\d/,/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else {
      this.mask = ['+',/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
	}


  setMask(){
    console.log("mask.length ", this.dropshipLocation.phone)
    // if(this.dropshipLocation.phone.length < 19){
      this.dropshipLocation.phone = this.applyMask(this.dropshipLocation.phone, this.mask);
    // }

    // this.maskLength=this.mask.length;
    // console.log("mask.length",this.mask,this.maskLength)




    // let formattedPhoneNumber = this.dropshipLocation.phone.replace(/\D/g, '');
    //
    // // Apply your desired phone number mask
    // if (this.maskLength === 11) {
    //   formattedPhoneNumber = formattedPhoneNumber.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    // } else if (this.maskLength === 10) {
    //   formattedPhoneNumber = formattedPhoneNumber.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    // } else if (this.maskLength > 11) {
    //   formattedPhoneNumber = formattedPhoneNumber.slice(0, 11);
    //   formattedPhoneNumber = formattedPhoneNumber.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    // }
    //
    // this.dropshipLocation.phone = formattedPhoneNumber;

  }


  // applyMask(inputString, mask) {
  //   let result = '';
  //   let maskIndex = 0;
  //
  //   if(inputString.length > 18){
  //     inputString = inputString.split
  //   }
  //
  //   for (let i = 0; i < inputString.length; i++) {
  //     const char = inputString.charAt(i);
  //     const maskChar = mask[maskIndex];
  //
  //     if (maskChar instanceof RegExp) {
  //       if (maskChar.test(char)) {
  //         result += char;
  //         maskIndex++;
  //       }
  //     } else {
  //       result += maskChar;
  //       if (char === maskChar) {
  //         maskIndex++;
  //       }
  //     }
  //   }
  //
  //   return result;
  // }

  applyMask(inputString, mask) {
    let result = '';
    let inputIndex = 0;

    // Iterate through the mask
    for (let i = 0; i < mask.length; i++) {
      const maskChar = mask[i];

      // If mask character is a placeholder
      if (typeof maskChar === 'string') {
        // If input string has more characters
        if (inputIndex < inputString.length) {
          result += inputString[inputIndex];
          inputIndex++;
        } else {
          // If input string is shorter, break
          break;
        }
      } else if (maskChar instanceof RegExp) {
        // If mask character is a regular expression
        const char = inputString[inputIndex];
        if (maskChar.test(char)) {
          result += char;
          inputIndex++;
        }
      }
    }

    return result;
  }

  addAdress(){
    this.gVLogger.log(this.dropshipLocation);
    if(this.validateForm())
      this.viewController.dismiss(this.dropshipLocation);
  }


  validateForm(){
    if(this.dropshipLocation.state == "" || this.dropshipLocation.country == "" || this.dropshipLocation.city == ""
    ){
      this.gVLogger.log("form validation failed");

      this.toastMsg("City, State and Country cannot not be empty");
      return false;
    }else{
      this.gVLogger.log("form validation pass");
      return true;
    }
  }

  cancelPopup(){
    this.viewController.dismiss(false);
  }

  toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }
  getCountries(){
    this.api.getRA("/api/v1/codes/all/0").subscribe(result=>{
      this.countries=result.json().data;
      console.log("CountryCodes from RA Service", this.countries);
    },err=>{
      console.log("Error", err);
    });
  }


  getProvinces(location,event){
    // if (event.isUserInput){
      location.state = ""
      let query = " ";
      let offset = 0;
      let resultcount = 100
      this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+event)
        .subscribe(data => {
          if(data.status == 401){
            // this.api.tokenExpiredLogout();
          }else{

            this.provinces =  data.json().lookups

            // this.paymentProcessingCode = data.json().lookups;
          }
        },err=>{
          console.log("Error", err);
        });
    // }

  }

  getProvincesWhileEditing(abbreviation){

    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+abbreviation)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{
          this.provinces =  data.json().lookups
        }
      },err=>{
        console.log("Error", err);
      });

  }

}



// WEBPACK FOOTER //
// ./src/pages/dropship-location-add-popup/dropship-location-add-popup.ts